<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader" v-if="vendorId"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft page-heading">
              <a class="mr-3" @click="$router.push({ path: '/app/vendors' })">
                <i class="material-icons">keyboard_backspace</i>
              </a>
              <h5 class="card-title alignLeft white-text">{{vendorId ? 'Update' : 'Add'}} Vendor</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 45px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy p-0 h-100">
                  <div class="card-content h-100" style="overflow:auto;position:relative">
                    <div class="row form">
                      <div class="col s12">
                        <form class="row form1" :class="{'bbline' : vendorId}">
                          <div class="col s12">
                            <h5 class="alignLeft">
                              Business Details
                              <div v-if="vendorId" class="save-btn text-center">
                                <button
                                  v-loader-button="isLoading"
                                  type="submit"
                                  name="action"
                                  class="btn round waves-effect waves-light"
                                >Save</button>
                              </div>
                            </h5>
                          </div>
                          <div class="col s12 p-0 mt-1">
                            <div class="input-field col s6">
                              <input
                                id="business_name"
                                v-model="vendorDetail.business_details.business_name"
                                name="business_name"
                                type="text"
                              />
                              <label for="business_name" class>Business Name</label>
                            </div>
                            <div class="input-field col s6">
                              <input
                                v-number-only
                                maxlength="10"
                                v-model="vendorDetail.business_details.business_contact"
                                name="business_contact"
                                id="business_contact"
                                type="text"
                              />
                              <label for="business_contact" class>Business Contact</label>
                            </div>
                            <div class="input-field col s6">
                              <input
                                id="rep_name"
                                v-model="vendorDetail.first_name"
                                name="rep_name"
                                type="text"
                              />
                              <label for="rep_name" class>Representative Name</label>
                            </div>
                            <div class="input-field col s6">
                              <input
                                v-model="vendorDetail.mobile_number"
                                v-number-only
                                maxlength="10"
                                :disabled="isEnableContact"
                                name="rep_contact"
                                id="rep_contact"
                                type="text"
                              />
                              <label for="rep_contact" class>Representative Contact</label>
                            </div>
                            <div class="input-field col s6">
                              <input
                                id="line1"
                                v-model="vendorDetail.business_details.address.line1"
                                name="line1"
                                type="text"
                              />
                              <label for="buisneline1ss_name" class>Address Line 1</label>
                            </div>
                            <div class="input-field col s6">
                              <input
                                v-model="vendorDetail.business_details.address.line2"
                                name="line2"
                                id="line2"
                                type="text"
                              />
                              <label for="business_contact" class>Address Line 2</label>
                            </div>
                            <div class="input-field col s4">
                              <input
                                id="city"
                                v-model="vendorDetail.business_details.address.city"
                                name="city"
                                type="text"
                              />
                              <label for="city" class>City</label>
                            </div>
                            <div class="input-field col s4">
                              <input
                                v-model="vendorDetail.business_details.address.state"
                                name="state"
                                id="state"
                                type="text"
                              />
                              <label for="state" class>State</label>
                            </div>
                            <div class="input-field col s4">
                              <input
                                v-number-only
                                maxlength="6"
                                v-model="vendorDetail.business_details.address.postcode"
                                name="postcode"
                                id="postcode"
                                type="text"
                              />
                              <label for="postcode" class>Pincode</label>
                            </div>
                          </div>
                          <div class="col s12 addblock" v-if="!vendorId">
                            <button
                              v-loader-button="isLoading"
                              type="submit"
                              name="action"
                              class="btn round waves-effect waves-light"
                            >Save</button>
                          </div>
                        </form>
                        <br />
                        <div class="row form2 bbline" v-if="vendorId">
                          <div class="col s12">
                            <h5 class="alignLeft">
                              Business Employees
                              <div class="save-btn text-center">
                                <button
                                  v-loader-button="isEmpLoading"
                                  @click="addEmployees()"
                                  class="btn round waves-effect waves-light"
                                >Save</button>
                              </div>
                            </h5>
                          </div>
                          <div class="col s12 martop employee">
                            <div
                              class="row workorder"
                              v-for="(item,index) in businessEmployees"
                              :key="item.idx"
                            >
                              <div class="col s5">
                                <div class="input-field">
                                  <input
                                    v-model="item.employee_name"
                                    :id="'empname' + item.idx"
                                    type="text"
                                  />
                                  <label :for="'empname' + item.idx" class>Employee Name</label>
                                </div>
                              </div>
                              <div class="col s4">
                                <div class="input-field">
                                  <input
                                    maxlength="10"
                                    v-number-only
                                    v-model="item.employee_contact"
                                    :id="'empcon' + item.idx"
                                    type="text"
                                  />
                                  <label :for="'empcon' + item.idx" class>Employee Contact</label>
                                </div>
                              </div>
                              <div class="col s3" v-if="businessEmployees.length>1">
                                <div class="action-btns">
                                  <a @click="deleteEmployee(item)" class="pointer delbtn">
                                    <img src="/assets/images/remove.svg" alt />
                                  </a>
                                </div>
                              </div>
                              <div
                                class="col s12"
                                v-if="index == businessEmployees.length - 1 && businessEmployees.length <= 10"
                              >
                                <div class="action-btns">
                                  <a @click="addMoreEmployee(item)" class="pointer">
                                    <span class="add-new-btn">
                                      <i class="material-icons">add</i>
                                    </span>
                                    Add another
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row form3" v-if="vendorId">
                          <div class="col s12">
                            <h5 class="alignLeft">
                              Services Provided
                              <div class="save-btn text-center">
                                <button
                                  v-if="selectedServices.length>0"
                                  @click="addServices()"
                                  class="btn round waves-effect waves-light"
                                >Add Services</button>
                              </div>
                            </h5>
                          </div>
                          <div class="col s12 martop">
                            <div class="row" style="height: calc(100% - 56px);">
                              <div class="col s12 vendors h-100">
                                <table class="responsive-table" v-if="allServiceList.length">
                                  <thead>
                                    <tr>
                                      <th data-field="index"></th>
                                      <th data-field="id">ID</th>
                                      <th data-field="name">Name</th>
                                      <th data-field="category">Category</th>
                                      <th data-field="descritption">Description</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(item,index) in allServiceList" :key="index">
                                      <td>
                                        <label>
                                          <input
                                            type="checkbox"
                                            v-model="item.checked"
                                            :name="'emp-check' + index"
                                            :id="'emp-check' + index"
                                            @change="getSelectedServices()"
                                          />
                                          <span></span>
                                        </label>
                                      </td>
                                      <td>{{item.service_id}}</td>
                                      <td>{{item.name}}</td>
                                      <td>{{item.category}}</td>
                                      <td v-html="getDesc(item.description)"></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vendorId: this.$route.params.id || "",
      isEnableContact: this.$route.params.id ? true : false,
      vendorDetail: {
        business_details: {
          address: {
            line1: "",
            line2: "",
            city: "",
            state: "",
            postcode: ""
          }
        }
      },
      serviceList: {
        results: [],
        count: 0
      },
      deletedEmployees: [],
      businessEmployees: [
        {
          idx: 1,
          employee_name: "",
          employee_contact: ""
        }
      ],
      isLoader: true,
      isLoading: false,
      isEmpLoading: false,
      isAddressLoading: false,
      errorMessage: "",
      isEdit: false,
      Validator: {},
      allServiceList: [],
      selectedServices: []
    };
  },
  created() {
    if (this.vendorId) {
      this.isLoader = true;
    } else {
      this.isLoader = false;
    }
    this.onCreated();
  },
  methods: {
    onCreated() {
      setTimeout(() => {
        var thisObj = this;
        this.Validator = $(".form1").validate({
          rules: {
            business_name: {
              required: true
            },
            business_contact: {
              required: true,
              minlength: 10,
              maxlength: 10
            },
            rep_name: {
              required: true
            },
            rep_contact: {
              required: true,
              minlength: 10,
              maxlength: 10
            },
            line1: {
              required: true
            },
            city: {
              required: true
            },
            state: {
              required: true
            },
            postcode: {
              required: true,
              minlength: 6,
              maxlength: 6
            }
          },
          errorElement: "div",
          errorPlacement: function(error, element) {
            var placement = $(element).data("error");
            if (placement) {
              $(placement).append(error);
            } else {
              error.insertAfter(element);
            }
          },
          submitHandler: e => {
            $("button").attr("disabled", "disabled");
            setTimeout(() => {
              $("button").removeAttr("disabled");
            }, 500);
            setTimeout(() => {
              thisObj.errorMessage = "";
              if (thisObj.isEdit) {
              } else {
                thisObj.addVendor();
              }
            }, 300);
            return false;
          }
        });
        if (this.vendorId) {
          this.retrieveVendor(this.vendorId);
        }
        this.initErrorLoopWatch();
      }, 500);
      this.getServiceList();
    },
    getServiceList() {
      ajax.get(Constants.default.APIURL.ListAllServices, res => {
        this.allServiceList = res.data;
        this.allServiceList.forEach(a => {
          a.checked = false;
        });
      });
    },
    initErrorLoopWatch() {
      setTimeout(() => {
        $(".employee input").on("keyup", e => {
          if (
            $(e.target)
              .next()
              .attr("class") == "error"
          ) {
            $(e.target)
              .next()
              .remove();
          }
        });
      }, 500);
    },
    addVendor() {
      let method = "";
      this.vendorId ? (method = "patch") : (method = "post");
      this.isLoading = true;
      ajax[method](
        Constants.default.APIURL.Vendors +
          (this.vendorId ? this.vendorId + "/" : ""),
        this.vendorDetail,
        res => {
          this.isLoading = false;
          Vue.toast(
            `Vendor business detail was ${
              this.vendorId ? "updated" : "added"
            } sucessfully.`
          );
          this.$router.push({ path: "/app/vendors" });
        },
        err => {
          this.isLoading = false;
          if (err.data.google_maps)
            this.errorMessage = `Google Maps - ${err.data.google_maps}`;
          else this.errorMessage = Vue.errorHandler(err);
          Vue.toast(this.errorMessage, "toast-error");
        }
      );
    },
    retrieveVendor(id) {
      ajax.get(
        Constants.default.APIURL.Vendors + id,
        res => {
          this.isLoader = false;
          this.vendorDetail = res.data;
          if (this.vendorDetail.business_details) {
            if (this.vendorDetail.business_details.employees.length > 0) {
              this.businessEmployees = this.vendorDetail.business_details.employees;
              this.businessEmployees.forEach((val, key) => {
                val.idx = key + 1;
              });
            }
            this.vendorDetail.business_details.services.forEach(val => {
              this.allServiceList.forEach((sVal, index) => {
                if (val.service.id == sVal.id) sVal.checked = true;
              });
            });

            this.getSelectedServices();
            if (this.vendorDetail.business_details.address == null) {
              this.vendorDetail.business_details.address = {
                line1: "",
                line2: "",
                city: "",
                state: "",
                postcode: ""
              };
            }
          }
          setTimeout(() => {
            this.Validator.resetForm();
            M.updateTextFields();
          }, 100);
        },
        err => {
          this.isLoader = false;
          this.errorMessage = Vue.errorHandler(err);
          Vue.toast(this.errorMessage, "toast-error");
        }
      );
    },
    addMoreEmployee(item) {
      if (item.employee_name && item.employee_contact) {
        if (item.employee_contact.length != 10) {
          $("#empcon" + item.idx).focus();
          setTimeout(() => {
            if ($("#employeee_contact-error").length == 0) {
              $("#empcon" + item.idx).after(
                `<div id="employeee_contact-error" class="error">Please enter at least 10 characters.</div>`
              );
            }
          }, 100);
          return;
        } else {
          $("#employeee_contact-error").remove();
        }
        this.businessEmployees.push({
          idx: this.businessEmployees.length + 1,
          employee_name: "",
          employee_contact: ""
        });
        this.initErrorLoopWatch();
      } else {
        if (!item.employee_contact) {
          $("#empcon" + item.idx).focus();
          setTimeout(() => {
            if ($("#employeee_contact-error").length == 0) {
              $("#empcon" + item.idx).after(
                `<div id="employeee_contact-error" class="error">This field is required.</div>`
              );
            }
          }, 100);
        }
        if (!item.employee_name) {
          $("#empname" + item.idx).focus();
          setTimeout(() => {
            if ($("#employeee_name-error").length == 0) {
              $("#empname" + item.idx).after(
                `<div id="employeee_name-error" class="error">This field is required.</div>`
              );
            }
          }, 100);
        }
      }
    },
    deleteEmployee(item) {
      let index = this.businessEmployees.findIndex(val => {
        return val.idx == item.idx;
      });
      this.deletedEmployees.push(this.businessEmployees[index].id);
      this.businessEmployees.splice(index, 1);
      this.businessEmployees.forEach((val, key) => {
        val.idx = key + 1;
      });
    },
    addEmployees() {
      let empArr = [],
        temp;
      let item = this.businessEmployees[this.businessEmployees.length - 1];
      if (item.employee_name && item.employee_contact) {
        if (item.employee_contact.length != 10) {
          $("#empcon" + item.idx).focus();
          setTimeout(() => {
            if ($("#employeee_contact-error").length == 0) {
              $("#empcon" + item.idx).after(
                `<div id="employeee_contact-error" class="error">Please enter at least 10 characters.</div>`
              );
            }
          }, 100);
          return;
        } else {
          $("#employeee_contact-error").remove();
        }
      } else {
        if (!item.employee_contact) {
          $("#empcon" + item.idx).focus();
          setTimeout(() => {
            if ($("#employeee_contact-error").length == 0) {
              $("#empcon" + item.idx).after(
                `<div id="employeee_contact-error" class="error">This field is required.</div>`
              );
            }
          }, 100);
        }
        if (!item.employee_name) {
          $("#empname" + item.idx).focus();
          setTimeout(() => {
            if ($("#employeee_name-error").length == 0) {
              $("#empname" + item.idx).after(
                `<div id="employeee_name-error" class="error">This field is required.</div>`
              );
            }
          }, 100);
        }
        return;
      }

      this.businessEmployees.forEach(val => {
        temp = JSON.parse(JSON.stringify(val));
        if (val.employee_name && val.employee_contact) {
          delete temp.idx;
          empArr.push(temp);
        }
      });
      if (empArr.length == 0) {
        return;
      }
      let method = "";
      let query = {
        business: this.vendorDetail.business_details.id,
        employees: empArr
      };
      if (this.vendorDetail.business_details) {
        if (this.vendorDetail.business_details.employees.length > 0) {
          delete query.business;
          query.deleted_employees = this.deletedEmployees;
          method = "patch";
        } else {
          method = "post";
        }
      } else {
        method = "post";
      }
      this.isEmpLoading = true;
      ajax[method](
        Constants.default.APIURL.BusinessEmployees +
          (method == "patch"
            ? this.vendorDetail.business_details.id + "/"
            : ""),
        query,
        res => {
          this.isEmpLoading = false;
          Vue.toast(
            `Vendor business employees was ${
              this.vendorDetail.business_details.employees.length > 0
                ? "updated"
                : "added"
            } sucessfully.`
          );
          this.retrieveVendor(this.vendorId);
        },
        err => {
          this.isEmpLoading = false;
          this.errorMessage = Vue.errorHandler(err);
          Vue.toast(this.errorMessage, "toast-error");
        }
      );
    },
    addServices() {
      let query = {
        business: this.vendorDetail.business_details.id,
        services: []
      };
      query.services = this.selectedServices.map(a => a.id);
      ajax.post(
        Constants.default.APIURL.VendorServices,
        query,
        res => {
          Vue.toast(`Vendor Services was updated sucessfully.`);
          this.retrieveVendor(this.vendorId);
        },
        err => {
          this.errorMessage = Vue.errorHandler(err);
          Vue.toast(this.errorMessage, "toast-error");
        }
      );
    },
    getDesc(des) {
      return des.slice(0, 150) + (des > 150 ? "..." : "");
    },
    getSelectedServices() {
      this.selectedServices = this.allServiceList.filter(a => a.checked);
    }
  },
  watch: {
    $route(to, from) {
      this.vendorId = this.$route.params.id;
      this.vendorDetail = {
        business_details: {
          address: {}
        }
      };
      this.selectedServices = [];
      this.deletedEmployees = [];
      this.businessEmployees = [
        {
          idx: 1,
          employee_name: "",
          employee_contact: ""
        }
      ];
      this.isLoading = false;
      this.isEmpLoading = false;
      this.isAddressLoading = false;
      this.errorMessage = "";
      (this.isEdit = false), this.onCreated();
    }
  }
};
</script>

<style lang="scss" scoped>
.input-field {
  height: 50px !important;
}
.form3 {
  margin-top: 15px;
  min-height: 200px;
  .martop {
    margin-top: 20px;
  }
}
.sub_btn {
  background: #04b48d;
  color: white !important;
}
.title-span {
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: calc(100% - 50px);
}

.ischecked {
  float: right;
  width: 40px;
  text-align: right;
  i {
    transition: 0.4s ease-in-out;
    opacity: 0;
    transform: scale(0) rotate(90deg);
    font-size: 30px;
    color: #04b48d;
  }
}

.form2 {
  .martop {
    margin-top: 20px;
  }
}
.bbline {
  border-bottom: 1px solid rgb(245, 239, 239);
}
.save-btn {
  float: right;
}
.addservice {
  i {
    font-size: 60px;
    color: #757575;
  }
}
.service_type span {
  background-color: #f4f6f8;
  border-radius: 4px;
  padding: 5px 10px;
}
i.selected {
  opacity: 1 !important;
  transform: scale(1) rotate(0deg) !important;
}
.inactive-block {
  position: absolute;
  height: 100%;
  width: 100%;
  display: none;
  align-items: flex-start;
  justify-content: flex-start;
  background: rgba(4, 180, 141, 0.07);
  z-index: 10;
  padding: 10px;
  opacity: 1;
  cursor: pointer;
  i {
    transition: 0.4s ease-in-out;
    opacity: 0;
    transform: scale(0) rotate(90deg);
    font-size: 35px;
    color: #04b48d;
  }
}

.workorder {
  .action-btns {
    margin: 10px 0 20px;
    text-align: left;
  }
}
.addblock {
  margin-top: 40px;
}
.page-heading {
  * {
    display: inline-block;
  }
  a {
    position: relative;
    top: 5px;
    cursor: pointer;
  }
}
h5.alignLeft {
  font-size: 20px;
}
</style>

